<template>
  <div class="root">
    <!-- 这个元素是凑数用的 -->
    <div class="flex-item-placeholder"></div>

    <div class="center" @keyup.enter="onClickLoginBtn">
      <div class="title">《{{ projectName }}》管理后台</div>
      <div class="form">
        <el-form label-width="80px">
          <el-form-item label="账号">
            <el-input
              v-model="username"
              maxlength="20"
              placeholder="请输入账号"
              prefix-icon="el-icon-user"
              autofocus
            ></el-input>
          </el-form-item>
          <el-form-item label="密码">
            <el-input
              v-model="password"
              maxlength="20"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
            ></el-input>
          </el-form-item>
        </el-form>
        <el-button
          @click="onClickLoginBtn"
          type="primary"
          style="margin-left: 5rem"
          >登录</el-button
        >
      </div>
    </div>

    <div class="footer">© 2023 深圳市创想手游科技有限公司</div>
  </div>
</template>

<script>
const axios = require("axios");
import util from "../util";
import store from "@/store";

export default {
  data() {
    return {
      projectName: "", // 项目名称
      username: "", // 用户名
      password: "", // 密码
    };
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 如果当前已经是处于登录状态了，就自动跳转到控制台首页
      let loginUser = util.getFromLocalStorage("loginUser");
      if (loginUser && loginUser.isLogin == "1") {
        vm.$router.push({ name: "console" });
      }
    });
  },

  created() {
    // 取得项目名称
    this.projectName = store.projectInfo.name;
  },

  methods: {
    /**
     * 点击了登录按钮
     */
    async onClickLoginBtn() {
      let username = this.username.trim();
      let password = this.password.trim();
      if (username.length == 0) {
        this.$message.error("请输入有效用户名");
        return;
      }
      if (password.length == 0) {
        this.$message.error("请输入有效密码");
        return;
      }

      try {
        let resData = (
          await axios.post(`${util.getBackendApiBase()}/v1/backstageLogin`, {
            username: username,
            password: password,
          })
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        // token
        let token = resData.data.token;

        // 记录登录状态
        util.storeToLocalStorage(
          "loginUser",
          {
            username: username,
            isLogin: "1",
            token: token,
          },
          60 * 60 * 24 * 7
        );

        // 跳转到控制台首页
        return this.$router.push({ name: "console" });
      } catch (e) {
        this.$message({
          message: e,
          type: "error",
        });
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.title {
  position: relative;
  top: -100px;
  font-size: 3rem;
}

.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .form {
    width: 25rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.footer {
  font-size: 0.8rem;
}
</style>